import DiscordIcon from "../../../../apps/web/src/components/logos/DiscordIcon";
import GoogleIcon from "../../../../apps/web/src/components/logos/GoogleIcon";
import TelegramLogo from "../../../../apps/web/src/components/logos/TelegramIcon";

export enum AuthProvider {
  TELEGRAM = "telegram",
  GOOGLE = "google",
  DISCORD = "discord",
  EMAIL = "email",
  WALLET = "wallet",
}

// Providers that do NOT require backend PIN confirmation for sensitive
// actions. Wallet users are authenticated cryptographically per request,
// so a server-issued PIN doesn't apply — bypass the prompt for them.
const whiteListedProviders = [AuthProvider.DISCORD, AuthProvider.WALLET];

export const doesProviderNeedPinConfirmation = (provider: AuthProvider) => {
  return !whiteListedProviders.includes(provider);
};
